<cc-container [fullWidth]="true">
  <div class="light-border">

    <form ccTableHeader class="search-form">
    <input type="text"
           ccInput
           matInput
           (keyup)="applyFilter($event.target.value)"
           placeholder="{{ 'LEAD_GENERATION.PROJECTS.SEARCH' | translate }}">

      <span class="last-n-days" translate>LEAD_GENERATION.PROJECTS.LAST_30_DAYS</span>
    </form>

    <mat-table
      #table
      matSort
      [dataSource]="matDataSource">

      <ng-container matColumnDef="name">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="name">
          <span translate>LEAD_GENERATION.PROJECTS.NAME </span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.NAME</cc-mobile-header>
          <cc-cell-container>
            <a class="text-info pointer text-ellipsis m-r-1" [routerLink]="['/lead-generation', 'projects', element.id, 'settings']" title="{{element.name}}">{{element.name}}</a>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="activeType">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="activeType">
          <span translate>LEAD_GENERATION.PROJECTS.TYPE</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.TYPE</cc-mobile-header>
          <cc-cell-container>
            <span>{{element.activeType}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="domain">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="domain">
          <span translate>LEAD_GENERATION.PROJECTS.DOMAIN</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>Domain</cc-mobile-header>
          <cc-cell-container>
            <span title="{{element.domain}}" class="text-ellipsis m-r-1">{{element.domain}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="device">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="device">
          <span translate>LEAD_GENERATION.PROJECTS.DEVICE</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.DEVICE</cc-mobile-header>
          <cc-cell-container>
            <span>{{element.device}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="impressions">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="impressions">
          <span translate>LEAD_GENERATION.PROJECTS.IMPRESSIONS</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.IMPRESSIONS</cc-mobile-header>
          <cc-cell-container>
            <span>{{element.impressions}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="leads">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="leads">
          <span translate>LEAD_GENERATION.PROJECTS.LEADS</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.LEADS</cc-mobile-header>
          <cc-cell-container>
            <span>{{element.leads}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="conversion">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="conversion">
          <span translate>LEAD_GENERATION.PROJECTS.CONVERSION_RATE</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.CONVERSION_RATE</cc-mobile-header>
          <cc-cell-container>
            <span>{{element.conversion}}%</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="status">
          <span translate>LEAD_GENERATION.PROJECTS.STATUS</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element">
          <cc-mobile-header translate>LEAD_GENERATION.PROJECTS.STATUS</cc-mobile-header>
          <cc-cell-container>
            <span
              class="status pointer"
              (click)="changeActivity(element)"
              [class.active]="element.status" translate>{{element.status ? 'ACTIVE' : 'INACTIVE'}}</span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <cc-empty-table-message *ngIf="matDataSource.data.length === 0">
      <span translate>LEAD_GENERATION.PROJECTS.NO_DATA </span>
    </cc-empty-table-message>
  </div>
</cc-container>
